import { Routes } from '@angular/router';

export const routes: Routes = [{
	path: "activate",
	loadChildren: () => import("./activate/activate.module").then(module => module.ActivateModule)
}, {
	path: "invite",
	loadChildren: () => import("./invite/invite.module").then(module => module.InviteModule)
}, {
	path: "team",
	loadChildren: () => import("./team/team.module").then(module => module.TeamModule)
}, {
	path: "dashboard",
	loadChildren: () => import("./dashboard/dashboard.module").then(module => module.DashboardModule)
}, {
	path: "forgot-password",
	loadChildren: () => import("./forgot-password/forgot-password.module").then(module => module.ForgotPasswordModule)
}, {
	path: "",
	loadChildren: () => import("./directory/directory.module").then(module => module.DirectoryModule)
}, {
	path: "",
	loadChildren: () => import("./jobs/jobs.module").then(module => module.JobsModule)
}, {
	path: "",
	loadChildren: () => import("./applicant/applicant.module").then(module => module.ApplicantModule)
}, {
	path: "login",
	loadChildren: () => import("./login/login.module").then(module => module.LoginModule)
}, {
	path: "logout",
	loadChildren: () => import("./logout/logout.module").then(module => module.LogoutModule)
}, {
	path: "register",
	loadChildren: () => import("./register/register.module").then(module => module.RegisterModule)
}];